import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/document-storage-and-archiving.jpg'),
    alt: 'document storage and archiving page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'document storage and archiving page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Document <span>Storage</span> <span>& Archiving For Businesses</span>',
  description:
    "Organize, store, and retrieve your important documents effortlessly with our secure and professional Document Storage Services. Whether you're looking to free up office space or need a reliable archiving solution, we’ve got you covered.",
  image: {
    url: '/images/v2/pages/main-pages/document-storage-and-archiving/hero-image.jpg',
    alt: 'document storage and archiving page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Store Your Documents Now' }
}

export const whyWeSectionContent = {
  title: 'How Our Document Storage Services Work',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get a Personalized Quote' },

  cards: [
    {
      id: 1,
      title: 'Book Your Service Online',
      description:
        'Easily schedule your document storage service online or by calling us. Select the service that fits your needs, and we’ll handle the rest.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/book-your-service-online.svg',
        alt: 'Book Your Service Online'
      }
    },
    {
      id: 2,
      title: 'Receive and Attach Labels',
      description:
        'We provide you with shipping labels by email or mail. Simply attach these labels to your document boxes or storage containers.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/receive-and-attach-labels.svg',
        alt: 'Receive and Attach Labels'
      }
    },
    {
      id: 3,
      title: 'Drop Off or Arrange Pickup',
      description:
        'Choose to drop off your labeled items at a FedEx or DHL location, or schedule a convenient pickup right from your office.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/drop-off-or-arrange-pickup.svg',
        alt: 'Drop Off or Arrange Pickup'
      }
    },
    {
      id: 4,
      title: 'Secure Storage & Easy Retrieval',
      description:
        'Your documents are securely stored in our climate-controlled facilities with advanced security systems. ',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/secure-storage-easy-retrieval.svg',
        alt: 'Secure Storage & Easy Retrieval'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Choose ShipAndStorage for Document Storage Services?',

  cards: [
    {
      id: 1,
      title: 'Advanced Security Measures',
      description:
        'Our storage facilities are equipped with 24/7 surveillance, restricted access, and disaster-proof systems.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/advanced-security-measures.svg',
        alt: 'Advanced Security Measures'
      }
    },
    {
      id: 2,
      title: 'Customizable Plans',
      description: 'We offer flexible storage options that adapt to your specific needs and timelines.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/customizable-plans.svg',
        alt: 'Customizable Plans'
      }
    },
    {
      id: 3,
      title: 'Seamless Document Access',
      description: 'Retrieve your files quickly and conveniently whenever you need them from any device, anywhere.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/seamless-document-access.svg',
        alt: 'Seamless Document Access'
      }
    },
    {
      id: 4,
      title: 'Climate-Controlled Facilities',
      description:
        'Protect sensitive documents like contracts, financial records, and legal files from environmental damage.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/climate-controlled-facilities.svg',
        alt: 'Climate-Controlled Facilities'
      }
    },
    {
      id: 5,
      title: 'Affordable Pricing',
      description: 'Our Document Storage Services come with transparent and cost-effective pricing options.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/affordable-pricing.svg',
        alt: 'Affordable Pricing'
      }
    },
    {
      id: 6,
      title: 'Professional Expertise',
      description: 'We handle your documents with care and confidentiality, ensuring your peace of mind.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/professional-expertise.svg',
        alt: 'Professional Expertise'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Secure Document and Archiving Storage Solutions',

  articles: [
    {
      link: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Discover More' },
      content: [
        {
          id: 1,
          description:
            'Store business documents securely and retrieve them when needed. Our archiving solutions are tailored for your business needs, whether you’re looking to store financial records, client contracts, or regulatory documents.'
        },
        {
          id: 2,
          points: [
            '<strong>Short-Term and Long-Term Storage:</strong> Flexible plans for businesses with varying needs.',
            '<strong>Digital Integration Options:</strong> Combine physical storage with digital backups for added security.',
            '<strong>Eco-Friendly Practices:</strong> Our facilities prioritize sustainability and eco-conscious storage practices.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/secure-document-and-archiving-storage-solutions.svg',
        alt: 'Secure Document and Archiving Storage Solutions'
      }
    }
  ]
}

export const proTipsSectionContent = {
  title: 'Pro Tips for Document Storage and Archiving',

  cards: [
    {
      id: 1,
      title: 'Book Your Service Online',
      description:
        'Easily schedule your document storage service online or by calling us. Select the service that fits your needs, and we’ll handle the rest.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/book-your-service-online.svg',
        alt: 'Book Your Service Online'
      }
    },
    {
      id: 2,
      title: 'Receive and Attach Labels',
      description:
        'We provide you with shipping labels by email or mail. Simply attach these labels to your document boxes or storage containers.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/receive-and-attach-labels.svg',
        alt: 'Receive and Attach Labels'
      }
    },
    {
      id: 3,
      title: 'Drop Off or Arrange Pickup',
      description:
        'Choose to drop off your labeled items at a FedEx or DHL location, or schedule a convenient pickup right from your office.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/drop-off-or-arrange-pickup.svg',
        alt: 'Drop Off or Arrange Pickup'
      }
    },
    {
      id: 4,
      title: 'Secure Storage & Easy Retrieval',
      description:
        'Your documents are securely stored in our climate-controlled facilities with advanced security systems. ',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/secure-storage-easy-retrieval.svg',
        alt: 'Secure Storage & Easy Retrieval'
      }
    }
  ]
}

export const industriesSectionContent = {
  title: 'Industries We Serve',
  description: 'Our Document Storage Services are trusted by various industries:',

  cards: [
    {
      id: 1,
      title: 'Legal Firms',
      description: 'Store case files, contracts, and confidential client records securely in a protected environment.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/legal-firms.svg',
        alt: 'Legal Firms'
      }
    },
    {
      id: 2,
      title: 'Healthcare Providers',
      description: 'Archive medical records, patient files, and compliance documents efficiently and safely.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/healthcare-providers.svg',
        alt: 'Healthcare Providers'
      }
    },
    {
      id: 3,
      title: 'Financial Institutions',
      description:
        'Ensure sensitive financial data, including reports and statements, is stored securely and remains compliant.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/financial-institutions.svg',
        alt: 'Financial Institutions'
      }
    },
    {
      id: 4,
      title: 'Educational Institutions',
      description: 'Manage student records, transcripts, and administrative files with organized storage solutions.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/educational-institutions.svg',
        alt: 'Educational Institutions'
      }
    },
    {
      id: 5,
      title: 'Corporate Offices',
      description: 'Optimize storage for contracts, HR documents, and business reports, ensuring easy retrieval.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/corporate-offices.svg',
        alt: 'Corporate Offices'
      }
    },
    {
      id: 6,
      title: 'Government Agencies',
      description:
        'Safeguard public records, permits, and legal documents in secure and climate-controlled facilities.',
      image: {
        src: '/images/v2/pages/main-pages/document-storage-and-archiving/government-agencies.svg',
        alt: 'Government Agencies'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Reliable Document and Archiving Storage Services at Your Fingertips',
  description:
    'Store business documents securely and retrieve them when needed. Our archiving solutions are tailored for your business needs.',
  image: {
    src: '/images/v2/pages/main-pages/document-storage-and-archiving/promotional-banner-image.svg',
    alt: 'Reliable Document and Archiving Storage Services at Your Fingertips'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'FAQs About Document Storage Services',

  questions: [
    {
      id: 1,
      question: 'What types of documents can I store?',
      answer: 'You can store financial records, legal files, contracts, medical records, and more.'
    },
    {
      id: 2,
      question: 'How secure are your storage facilities?',
      answer:
        'Our facilities feature 24/7 surveillance, restricted access, and fireproof systems to ensure the highest level of security.'
    },
    {
      id: 3,
      question: 'Can I retrieve my documents anytime?',
      answer: 'Yes, our on-demand retrieval services allow you to access your files whenever needed.'
    },
    {
      id: 4,
      question: 'Do you offer climate-controlled storage?',
      answer: 'Absolutely! We provide climate-controlled units to protect sensitive and valuable documents.'
    },
    {
      id: 5,
      question: 'How much do your Document Storage Services cost?',
      answer: 'Pricing depends on the volume and duration of storage. Contact us for a customized quote.'
    }
  ]
}
